<template>
  <div class="page">
    <div class="pagebanner pagebanner1" :style="{background:'url('+pagebanner+') center 0 no-repeat'}">
      <div class="w1200">
        <h1 class="bounceInUp wow" data-wow-duration="1s" data-wow-delay="0">{{pagetitle}}</h1>
        <span class="bounceInUp wow" data-wow-duration="1s" data-wow-delay="0.2s">{{pagedesc}}</span>
      </div>
    </div>
    <div class="page-location">
      <div class="w1200">
        <ul class="pagenav">
          <li>
            <a href="javascript:;" @click="$router.push({name: 'environment'})">{{ $t('anquanhuanbao')}}</a>
          </li>
          <li>
            <a href="javascript:;" @click="$router.push({name: 'welfare'})">{{ $t('welfare')}}</a>
          </li>
          <li class="s">
            <a href="javascript:;" @click="$router.push({name: 'care'})">{{ $t('care')}}</a>
          </li>
        </ul>
      </div>
    </div>
    <div class="page-main">
      <div class="w1200">
        <div class="page-content" v-html="content">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Fetch from '../js/ajax'
export default {
  name: 'Environment',
  metaInfo () {
    return {
      meta: [{
        name: 'keywords',
        content: '浙江金科日化原料有限公司,氧系漂白助剂过碳酸钠,SPC'
      }]
    }
  },
  data () {
    return {
      pagetitle: '',
      pagedesc: '',
      pagebanner: '',
      content: ''
    }
  },
  mounted () {
  },
  methods: {
  },
  created () {
    const that = this
    Fetch.post('Api/column', {
      id: 5
    }).then((res) => {
      that.pagetitle = res.result.title
      that.pagedesc = res.result.sub_title
      that.pagebanner = res.result.image
    }).catch(err => {
      console.log(err)
    })
    Fetch.post('Api/care', {
    }).then((res) => {
      that.content = res.result.content
    }).catch(err => {
      console.log(err)
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .page-main{
    min-height: 400px;
    padding: 0 40px;
    overflow: hidden;
  }
  .pagebanner{
    height: 600px;
    overflow: hidden;
  }
  .pagebanner5{
    background: url(../assets/pagebanner5.png) center 0 no-repeat;
  }
  .pagebanner h1{
    height: 60px;
    display: block;
    line-height: 60px;
    margin-top: 271px;
    text-align: center;
    font-size: 40px;
    font-weight: bold;
    color: #fff;
  }
  .pagebanner span{
    overflow: hidden;
    height: 41px;
    display: block;
    line-height: 41px;
    text-align: center;
    font-size: 20px;
    color: #fff;
  }
  .page-location{
    height: 60px;
    background-color: #F4F4F4;
  }
  .pagenav{
    width: 100%;
    height: 60px;
    display: flex;
    justify-content:center;
  }
  .pagenav li{
    min-width: 168px;
    height: 60px;
  }
  .pagenav li a{
    display: block;
    width: auto;
    height: 100%;
    padding: 0 5px;
    line-height: 60px;
    text-align: center;
    color: #999999;
    margin: 0 5px;
    font-size: 14px;
  }
  .pagenav .s a,.pagenav li:hover a{
    color: #E40A1F;
    font-size: 16px;
    font-weight: bold;
    background-color: #fff;
  }
  .page-content{
    width: 100%;
    height: auto;
    overflow: hidden;
    padding: 0 30px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/care.vue